'use client';

import { SlidersHorizontal } from 'lucide-react';
import { Children, Fragment, type ReactNode } from 'react';
import { cn } from '@/lib/utils';

/** 与下载 / 历史 / 高级工具栏按钮同一套尺寸与字重（含 Button size=sm 的 has-svg 内边距） */
export const TOOLBAR_GHOST_ITEM_CN =
  'inline-flex h-8 shrink-0 items-center gap-1.5 whitespace-nowrap rounded-md px-2 text-xs font-medium has-[>svg]:px-2.5';

type InlineOptionsRowProps = {
  children: ReactNode;
  className?: string;
};

/**
 * Inline 开关行：左缘、字号、图标尺寸与底部 ghost 按钮对齐。
 */
export function InlineOptionsRow({ children, className }: InlineOptionsRowProps) {
  const items = Children.toArray(children).filter(Boolean);
  if (!items.length) return null;

  return (
    <div className={cn(TOOLBAR_GHOST_ITEM_CN, className)}>
      <SlidersHorizontal size={12} className="mr-1 shrink-0" aria-hidden />
      {items.map((child, idx) => (
        <Fragment key={idx}>
          {idx > 0 ? (
            <span className="h-3 w-px shrink-0 self-center bg-foreground/20" aria-hidden />
          ) : null}
          {child}
        </Fragment>
      ))}
    </div>
  );
}
